import { z } from 'zod';

export const validationStateSchema = z.object({
	errors: z.record(z.string(), z.array(z.string())),
});

export type ValidationStoreState = z.infer<typeof validationStateSchema>;
